module.exports = __webpack_public_path__ + "static/media/icon-dash-risks.94eb4de7.png";